import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("knovas_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setAdminToken = (t) => {
  if (t) localStorage.setItem("knovas_admin_token", t);
  else localStorage.removeItem("knovas_admin_token");
};

export const getAdminToken = () => localStorage.getItem("knovas_admin_token");
